<div class="iss-page-title-bar iss-container">
  <ng-container *ngIf="template; else fallback">
    <ng-container [ngTemplateOutlet]="template" />
  </ng-container>
  <iss-slot id="page-title-bar-slot"/>
  <ng-template #fallback>
    {{ title }}
  </ng-template>
</div>
